var exports = {
  "HM": "UserAreaSkeleton.module__userArea___SU1lVG",
  "nd": "UserAreaSkeleton.module__panel___SU1lVG",
  "zl": "UserAreaSkeleton.module__voicePanel___SU1lVG",
  "Qs": "UserAreaSkeleton.module__content___SU1lVG",
  "D_": "UserAreaSkeleton.module__identity___SU1lVG",
  "Ky": "UserAreaSkeleton.module__identityText___SU1lVG",
  "S7": "UserAreaSkeleton.module__nameRow___SU1lVG",
  "jf": "UserAreaSkeleton.module__statusRow___SU1lVG",
  "ne": "UserAreaSkeleton.module__controls___SU1lVG",
};

module.exports = exports;
